export default {
  FORM_EDITOR_FIELD_CHANGED: 'FORM_EDITOR_FIELD_CHANGED',
  FORM_EDITOR_CONFIGURATION_CHANGED: 'FORM_EDITOR_CONFIGURATION_CHANGED',
  FORM_EDITOR_QUESTIONS_VALID_CHANGED: 'FORM_EDITOR_QUESTIONS_VALID_CHANGED',

  CREATE_FORM_TEMPLATE: 'CREATE_FORM_TEMPLATE',
  LOAD_FORM_TEMPLATE_BEGIN: 'LOAD_FORM_TEMPLATE_BEGIN',
  LOAD_FORM_TEMPLATE_SUCCESS: 'LOAD_FORM_TEMPLATE_SUCCESS',
  LOAD_FORM_TEMPLATE_FAILURE: 'LOAD_FORM_TEMPLATE_FAILURE',

  SAVE_FORM_TEMPLATE_BEGIN: 'SAVE_FORM_TEMPLATE_BEGIN',
  SAVE_FORM_TEMPLATE_SUCCESS: 'SAVE_FORM_TEMPLATE_SUCCESS',
  SAVE_FORM_TEMPLATE_FAILURE: 'SAVE_FORM_TEMPLATE_FAILURE',
  RESET_FORM_EDITOR_STATE: 'RESET_FORM_EDITOR_STATE',

  LOAD_QUESTION_BANK_BEGIN: 'LOAD_QUESTION_BANK_BEGIN',
  LOAD_QUESTION_BANK_SUCCESS: 'LOAD_QUESTION_BANK_SUCCESS',
  LOAD_QUESTION_BANK_FAILURE: 'LOAD_QUESTION_BANK_FAILURE',

};